import { useLocalSearchParams } from 'expo-router';

import { BlockUser } from '@/screens/block-user';

export default function BlockUserRoute() {
  const { userId } = useLocalSearchParams<{ userId: string }>();
  return <BlockUser userId={userId} />;
}
